import React from 'react';
import { Route, Switch } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { COMPONENT_TYPES } from '@atlas/routing';

import Promotions from './Promotions';
import PromotionsDetails from './PromotionsDetails';

const { PROMOTIONS } = COMPONENT_TYPES;

const PromotionsRouter = () => {
  const competitionPath = SiteConfigManager.getComponentPath(PROMOTIONS);

  return (
    <Switch>
      <Route component={PromotionsDetails} path={`${competitionPath}/:id`} />
      <Route component={Promotions} path={`${competitionPath}`} />
    </Switch>
  );
};

export default PromotionsRouter;
